import * as React from 'react'
import { Outlet, useOutletContext } from 'react-router-dom'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import { PolicyDetailTabs } from 'modules/timeoff/components/TimeoffPolicy/PolicyDetailTabs'
import TimeoffPolicyDetails from 'modules/timeoff/components/TimeoffPolicy/TimeoffPolicyDetails'
import type { RouteContextParams } from 'modules/timeoff/lib/routeContextParams'

const TimeoffPolicyDetailsPage = () => {
  const { tabs, back, title, policy, isNotFound, loading } = useOutletContext<RouteContextParams>()

  return (
    <ResponsivePage.Body loading={loading} error={null} showHeader={false}>
      <PolicyDetailTabs tabs={tabs} />
      <TimeoffPolicyDetails policy={policy}>
        <Outlet context={{ tabs, back, title, policy, isNotFound }} />
      </TimeoffPolicyDetails>
    </ResponsivePage.Body>
  )
}

export default TimeoffPolicyDetailsPage
